import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Alert, Badge, Button, Form, Table } from 'react-bootstrap';
import { DescriptionOutlined } from '@mui/icons-material';
import { apiService } from '../services/apiService';
import ProjectDirectory from './ProjectDirectory';

export default function ProjectList() {
  const [projects, setProjects] = useState(null);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');
  const [scope, setScope] = useState('all');
  useEffect(() => {
    let active = true;
    apiService.listProjects().then(result => { if (active) setProjects(result.projects); })
      .catch(failure => { if (active) setError(failure.response?.data?.error || failure.message); });
    return () => { active = false; };
  }, []);
  const visible = (projects || []).filter(project => {
    const matchesScope = scope === 'all' || (scope === 'owned' ? project.is_owner : !project.is_owner);
    return matchesScope && [project.name, project.description, project.owner_email, project.role]
      .some(value => String(value || '').toLowerCase().includes(search.trim().toLowerCase()));
  });
  return <div className="bomwise-workspace">
    <ProjectDirectory />
    <div className="bomwise-page-heading">
      <div><div className="bomwise-eyebrow">INDIVIDUAL BOMS</div><h2>My BOMs</h2>
        <p className="text-muted mb-0">Your parts, projects, and collaborators. One place to keep work moving.</p></div>
      <Button as={Link} to="/upload">Upload BOM</Button>
    </div>
    {error && <Alert variant="danger">{error}</Alert>}
    {!projects && !error && <p>Loading…</p>}
    {projects && <section className="bomwise-worksheet" aria-label="Your BOMs">
      <div className="bomwise-workspace-stats">
        <div><span>All BOMs</span><strong>{projects.length}</strong></div>
        <div><span>Owned by you</span><strong>{projects.filter(project => project.is_owner).length}</strong></div>
        <div><span>Shared with you</span><strong>{projects.filter(project => !project.is_owner).length}</strong></div>
      </div>
      <div className="bomwise-worksheet-toolbar">
        <div className="bomwise-scope-tabs" role="group" aria-label="Filter BOM ownership">
          {[['all', 'All BOMs'], ['owned', 'Owned'], ['shared', 'Shared with me']].map(([value, label]) =>
            <Button key={value} size="sm" variant={scope === value ? 'primary' : 'light'}
              aria-pressed={scope === value} onClick={() => setScope(value)}>{label}</Button>)}
        </div>
        <Form.Control size="sm" className="bomwise-worksheet-search" aria-label="Search projects"
          placeholder="Search your BOMs…" value={search} onChange={event => setSearch(event.target.value)} />
      </div>
      {visible.length > 0 ? <Table responsive hover className="bomwise-project-table mb-0"><thead><tr><th>BOM name</th><th>Owner</th><th>Access</th><th>Status</th><th><span className="visually-hidden">Open BOM</span></th></tr></thead>
      <tbody>{visible.map(project => <tr key={project.bom_id}>
        <td><div className="d-flex align-items-start gap-2"><DescriptionOutlined className="text-primary" fontSize="small" /><div>
          <Link to={`/bom/${encodeURIComponent(project.bom_id)}`}>{project.name}</Link>
          {project.description && <div className="bomwise-project-description text-muted">{project.description}</div>}</div></div></td>
        <td>{project.is_owner ? 'You' : project.owner_email || 'Another account'}</td>
        <td><Badge bg={project.is_owner ? 'primary' : 'secondary'}>{project.is_owner ? 'Owned by you' : 'Shared with you'}</Badge>
          <span className="ms-2">{project.role}</span></td><td><Badge bg={project.status === 'ready' ? 'success' : project.status === 'failed' ? 'danger' : 'secondary'}>{project.status}</Badge></td>
        <td><Link to={`/bom/${encodeURIComponent(project.bom_id)}`} aria-label={`Open ${project.name}`}>Open →</Link></td>
      </tr>)}</tbody>
    </Table> : <div className="bomwise-empty-state">
      <DescriptionOutlined /><h2>{projects.length ? 'No matching BOMs' : 'Your next project starts here'}</h2>
      <p>{projects.length ? 'Try a different search or ownership filter.' : 'Upload a CSV or Excel file to start managing and sharing your parts.'}</p>
      {projects.length ? <Button variant="outline-primary" onClick={() => { setSearch(''); setScope('all'); }}>Reset filters</Button>
        : <Button as={Link} to="/upload">Upload your first BOM</Button>}
    </div>}
      <div className="bomwise-worksheet-footer"><span>{visible.length} of {projects.length} BOMs</span><span>Only BOMs accessible to your account are listed.</span></div>
    </section>}
    <p className="bomwise-workspace-note">General-link shares appear after you open and redeem the link. Each BOM retains its own sharing permissions.</p>
  </div>;
}
